import { GlobalState } from '../actions';

const radioEinsSelector = (state: GlobalState) => state.radioEins;

export const radioEinsWeeklyCommentSelector = (state: GlobalState) => radioEinsSelector(state).weeklyComment;
